import chunk from 'lodash/chunk'

const cash: Record<string, number> = {}

export const calcBrightness = (hexColor: string) => {
	if (cash.hasOwnProperty(hexColor)) {
		return cash[hexColor]
	}
	if (!hexColor || hexColor.length !== 7) return 0

	const colorComponents = chunk(hexColor.slice(1), 2).map(color =>
		color.join('')
	)

	const [R, G, B] = colorComponents.map(component =>
		calcColorLinearValue(parseInt(component, 16))
	)
	const brightness = 0.2126 * R + 0.7152 * G + 0.0722 * B
	cash[hexColor] = brightness
	return brightness
}

const calcColorLinearValue = (color: number) => {
	if (color > 255 || color < 0) {
		throw new Error('Неверное значение компоненты цвета')
	}
	const realValue = color / 255
	if (realValue > 0.03928) {
		return ((realValue + 0.055) / 1.055) ** 2.4
	} else return realValue / 12.92
}
